import { Checkbox, Stack } from "@shopify/polaris";
import { useCallback } from "react";

const DisableActionField = ({ input }) => {
  const handleChangeDisable = useCallback(() => {
    input.onChange({ ...input.value, disableAction: !input.value.disableAction });
  }, [input]);

  return (
    <Stack alignment={"center"}>
      <Checkbox
        label="Disable this action on a specific date and time"
        checked={input.value.disableAction}
        onChange={handleChangeDisable}
      />
      {/*<Tooltip*/}
      {/*    content='All dates and times within Stockhide are based on the UTC timezone.'*/}
      {/*    padding={'4'}*/}
      {/*    preferredPosition={'above'}*/}
      {/*>*/}
      {/*    <Icon*/}
      {/*        source={AlertMinor}*/}
      {/*        color="base"*/}
      {/*    />*/}
      {/*</Tooltip>*/}
    </Stack>
  );
};

export default DisableActionField;